{
    "deckActionCardDraw": {
        "cards": [
            {
                "name": "Starter_Fishing_2"
            },
            {
                "name": "Starter_Chopping"
            },
            {
                "name": "Starter_Mining"
            },
            {
                "name": "Starter_Chopping_2"
            }
        ]
    },
    "deckActionCardDiscard": {
        "cards": []
    },
    "deckActionDrawLeft": {
        "cards": [
            {
                "name": "Season3Action_Geologist"
            },
            {
                "name": "Season3Action_AntiAntiSocial"
            },
            {
                "name": "Season3Action_LakeFisher"
            },
            {
                "name": "Season2Action_JackOfAllTrades"
            },
            {
                "name": "Season2Action_GeneralistMedalEarner"
            },
            {
                "name": "Season2Action_Excavator"
            },
            {
                "name": "Season2Action_AmateurFarmer"
            },
            {
                "name": "Season1Action_FarmClearer"
            },
            {
                "name": "Season1Action_RiverFisher"
            },
            {
                "name": "Season1Action_FarmFisher"
            },
            {
                "name": "Season1Action_FarmMiner"
            }
        ]
    },
    "deckActionDrawRight": {
        "cards": [
            {
                "name": "Season3Action_Delver"
            },
            {
                "name": "Season3Action_Kingfisher"
            },
            {
                "name": "Season3Action_Completist"
            },
            {
                "name": "Season2Action_LumberjackFisher"
            },
            {
                "name": "Season2Action_ProjectDabbler"
            },
            {
                "name": "Season2Action_Collector"
            },
            {
                "name": "Season2Action_SecretMineFisher"
            },
            {
                "name": "Season1Action_NoviceForager"
            },
            {
                "name": "Season1Action_WoodScrapper"
            },
            {
                "name": "Season1Action_EnergyEnthusiast"
            },
            {
                "name": "Season1Action_Grower"
            }
        ]
    },
    "deckActionCardActive": {
        "cards": [
            {
                "name": "Starter_Tending"
            },
            {
                "name": "Starter_Fishing"
            },
            {
                "name": "Starter_Tending_2"
            },
            {
                "name": "Starter_ZenithOrders"
            },
            {
                "name": "Starter_Mining_2"
            }
        ]
    },
    "objectiveOne": {
        "name": "Objective_S1_Clearer"
    },
    "objectiveTwo": {
        "name": "Objective_S2_Upgrader"
    },
    "objectiveThree": {
        "name": "Objective_S3_Assembler"
    },
    "randomSeed": {
        "seed": 27
    }
}